import I18N from '@leverege/i18n'
import React from 'react'

import StationTimeline from './StationTimeline'
import StationTimelineModel from './StationTimelineModel'

const id = 'ps.dataViewers.StationTimelineSupportDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'ps.StationTimelineSupport',
  name : tf( 'name', 'Station Timeline Support' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : 'none',
  matches : { type : 'GroupDataViewer', objectType : 'station' },
  createSettings : ( props ) => {
    return StationTimelineModel.create()
  },
  render : ( props ) => {
    return React.createElement( StationTimeline, props )
  },
  getDefaultCardContentOptions : { height : 'auto' },
}
